module.exports = {
    SUPER_BANNER_OPEN: 'SUPER_BANNER_OPEN',
};
